import { render } from "./BusinessProtectionPlanSelection.vue?vue&type=template&id=8d7820e0&scoped=true"
import script from "./BusinessProtectionPlanSelection.vue?vue&type=script&lang=js"
export * from "./BusinessProtectionPlanSelection.vue?vue&type=script&lang=js"

import "./BusinessProtectionPlanSelection.vue?vue&type=style&index=0&id=8d7820e0&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d7820e0"]])

export default __exports__